<ng-container *transloco="let t; prefix: 'fuelReconciliation'">
<div class="main-table fuel-recon-table">
  <div class="table-scroll-wrapper">
  <table class="table reconciled-table">
    <thead>
      <tr>
        <th>
          <div class="sort-btn">
            {{ t('reconciledTable.reconcileDate') }}
            <button class="filter-button" (click)="sortByColumn('reconcileDate')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th>
          <div class="sort-btn">
            {{ t('reconciledTable.asset') }}
            <button class="filter-button" (click)="sortByColumn('assetName')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="fuel-recon-cell">
          <div class="sort-btn">
            {{ t('reconciledTable.fuelSlipDate') }}
            <button class="filter-button" (click)="sortByColumn('fuelSlipDate')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="fuel-recon-cell">
          <div class="sort-btn">
            {{ t('reconciledTable.fuelProbeReading') }}
            <button class="filter-button" (click)="sortByColumn('fuelProbeReading')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="fuel-recon-cell">
          <div class="sort-btn">
            {{ t('reconciledTable.fuelSlipAmount') }}
            <button class="filter-button" (click)="sortByColumn('fuelSlipAmount')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="fuel-recon-cell">
          <div class="sort-btn">
            {{ t('reconciledTable.cost') }}({{currencySymbol}})
            <button class="filter-button" (click)="sortByColumn('cost')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="difference-volume">
          <div class="sort-btn">
            {{ t('reconciledTable.differenceInVolume') }}
            <button class="filter-button" (click)="sortByColumn('differenceInVolume')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="difference-percentage">
          <div class="sort-btn">
            {{ t('reconciledTable.differenceInPercentage') }}
            <button class="filter-button" (click)="sortByColumn('differenceInPercentage')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </div>
        </th>
        <th class="action-col">{{ t('reconciledTable.action') }}</th>
      </tr>
    </thead>

    @if (isLoading) {
      <tbody>
        <tr>
          <td colspan="9">
            <div class="spinner-container">
              <span class="spinner-border text-light"></span>
            </div>
          </td>
        </tr>
      </tbody>
    } @else {
      <tbody>
        @if (!reconciledFuel?.length && hasError) {
          <tr>
            <td colspan="9" class="no-data">
              <app-error-state></app-error-state>
            </td>
          </tr>
        } @else if (!reconciledFuel?.length) {
          <tr>
            <td colspan="9" class="no-data">
              <app-empty-state></app-empty-state>
            </td>
          </tr>
        }
        @for (fuelSlip of reconciledFuel; track fuelSlip.fuelSlipImportsId; let i = $index) {
          <tr>
            <td>{{ fuelSlip.reconcileDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="asset"><strong>{{ fuelSlip.assetName }}</strong></td>
            <td class="fuel-recon-cell">{{ fuelSlip.fuelSlipDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="fuel-recon-cell">{{ fuelSlip.fuelProbeReading }} ℓ</td>
            <td class="fuel-recon-cell">{{ fuelSlip.fuelSlipAmount }} ℓ</td>
            <td class="fuel-recon-cell">
              {{ fuelSlip.cost
              ? currencySymbol + fuelSlip.cost.toLocaleString() + (fuelSlip.isTotalCost ? '' : '/ℓ' ) : currencySymbol + '0'
              }}
            </td>
            <td class="difference-volume">{{ fuelSlip.differenceInVolume }} ℓ</td>
            <td class="difference-percentage">
              <div class="difference-box">
                <p [class]="isWithinTwoPercentMargin(fuelSlip) ? 'within-margin' : 'outside-margin'">
                  {{ fuelSlip.differenceInPercentage.toFixed(2) }}%</p>
              </div>
            </td>
            <td class="action-col">
              <div class="kebab-menu-wrapper">
                <button class="kebab-btn" (click)="toggleMenu(i, $event)">
                  <img src="assets/icons/ellipsis-options.svg" alt="options" />
                </button>
                @if (openMenuId === i) {
                  <div class="kebab-dropdown"
                    [style.bottom.px]="dropdownPos.bottom"
                    [style.right.px]="dropdownPos.right">
                    <button class="kebab-item" (click)="openEdit(fuelSlip, i)">{{ t('reconciledTable.edit') }}</button>
                    <button class="kebab-item" (click)="openViewAttachment(fuelSlip)">{{ t('reconciledTable.viewAttachment') }}</button>
                    <button class="kebab-item kebab-item--danger" (click)="openDelete(fuelSlip)">{{ t('reconciledTable.delete') }}</button>
                  </div>
                }
              </div>
            </td>
          </tr>

          @if (expandedRowIndex === i) {
            <tr class="edit-details-row">
              <td colspan="9">
                <div class="edit-details-content">
                  <div class="edit-frame">

                    <div class="field-group">
                      <label>{{ t('reconciledTable.attach') }}</label>
                      <input type="file" hidden #editFileInput (change)="onEditFileSelected($event)">
                      @if (editSelectedFile) {
                        <div class="file-selected-label">
                          <img src="assets/icons/file-icon.svg" alt="file" class="file-icon" />
                          <div class="file-info">
                            <span class="file-name">{{ editSelectedFile.name }}</span>
                            <span class="file-success">{{ t('reconciledTable.fileUploadSuccess') }}</span>
                          </div>
                          <button type="button" class="view-file-btn" (click)="previewEditFile()">
                            <img src="assets/icons/eye-icon.svg" alt="view" />
                          </button>
                          <button type="button" class="remove-file-btn" (click)="removeEditFile()">
                            <img src="assets/icons/trash-icon.svg" alt="remove" />
                          </button>
                        </div>
                      } @else if (fuelSlip.originalFileName) {
                        <div class="file-selected-label">
                          <img src="assets/icons/file-icon.svg" alt="file" class="file-icon" />
                          <div class="file-info">
                            <span class="file-name">{{ fuelSlip.originalFileName || 'Fuel slip #' + fuelSlip.fuelSlipImportsId }}</span>
                            <span class="file-success">{{ t('reconciledTable.existingAttachment') }}</span>
                          </div>
                          <button type="button" class="view-file-btn" (click)="openViewAttachment(fuelSlip)">
                            <img src="assets/icons/eye-icon.svg" alt="view" />
                          </button>
                          <button type="button" class="remove-file-btn" (click)="clearExistingAttachment(fuelSlip)">
                            <img src="assets/icons/trash-icon.svg" alt="remove" />
                          </button>
                        </div>
                      } @else {
                        <p class="browse-files-label">
                          {{ t('reconciledTable.attachHint') }}
                          <button type="button" class="browse-files-btn" (click)="editFileInput.click()">{{ t('reconciledTable.browseFiles') }}</button>
                        </p>
                      }
                    </div>

                    <div class="field-group">
                      <label>{{ t('reconciledTable.volume') }} <span class="required">*</span></label>
                      <input type="number" class="volume-input" [placeholder]="t('reconciledTable.volumePlaceholder')"
                        [(ngModel)]="editAmount" min="0">
                    </div>

                    <div class="field-group">
                      <label>{{ t('reconciledTable.costType') }} <span class="required">*</span></label>
                      <div class="cost-type-dropdown common-drop-down dropdown">
                        <input type="text" class="dropdown-toggle cost-type-input"
                          [value]="editCostType || t('reconciledTable.selectCostType')" readonly
                          data-bs-toggle="dropdown" aria-expanded="false" />
                        <ul class="dropdown-menu cost-type-menu">
                          <li>
                            <button class="dropdown-item" type="button" (click)="selectEditCostType('Cost/ℓ')">{{ t('reconciledTable.costPerLitre') }}</button>
                          </li>
                          <li>
                            <button class="dropdown-item" type="button" (click)="selectEditCostType('Total Cost')">{{ t('reconciledTable.totalCost') }}</button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="field-group">
                      <label>{{ t('reconciledTable.fuelSlipAmount') }} <span class="required">*</span></label>
                      <div class="d-flex align-items-center">
                        <div class="currency-dropdown common-drop-down dropdown">
                          <button type="button" class="dropdown-toggle currency-input" data-bs-toggle="dropdown" aria-expanded="false">
                            <div class="currency-display-content">
                              @if (editSelectedCurrency) {
                                <app-country-flag [countryCode]="editSelectedCurrency.code"
                                  [name]="editSelectedCurrency.name" [size]="18" [rounded]="true"></app-country-flag>
                              }
                              <span class="currency-text">{{ editSelectedCurrency?.code || t('reconciledTable.currency') }}</span>
                            </div>
                          </button>
                          <ul class="dropdown-menu currency-list-menu">
                            <li class="currency-search-wrapper">
                              <div class="input-group">
                                <span class="search-icon" aria-hidden="true"></span>
                                <input type="text" class="currency-search-input" [placeholder]="t('reconciledTable.searchCurrency')"
                                  [(ngModel)]="editCurrencySearchTerm" (ngModelChange)="filterEditCurrencies()"
                                  (click)="$event.stopPropagation()" />
                              </div>
                            </li>
                            @for (currency of filteredCurrencies; track currency.id) {
                              <li class="currency-item" [class.selected]="editSelectedCurrency?.code === currency.code">
                                <button class="dropdown-item" type="button" (click)="selectEditCurrency(currency)">
                                  <div class="currency-item-content">
                                    <app-country-flag [countryCode]="currency.code" [name]="currency.name" [rounded]="true"></app-country-flag>
                                    <div class="currency-info">
                                      <span class="currency-code">{{ currency.code }}</span>
                                      <span class="currency-name">{{ currency.name }}</span>
                                    </div>
                                  </div>
                                  <div class="currency-checkbox" [class.checked]="editSelectedCurrency?.code === currency.code"></div>
                                </button>
                              </li>
                            } @empty {
                              <li class="no-results">{{ t('reconciledTable.noCurrenciesFound') }}</li>
                            }
                          </ul>
                        </div>
                        <input type="number" class="amount-input" placeholder="0.00" [(ngModel)]="editCost" min="0">
                      </div>
                    </div>

                    <div class="field-group action-buttons">
                      <button class="cancel-btn" (click)="cancelEdit()">{{ 'common.cancel' | transloco }}</button>
                      <button class="update-btn" [disabled]="isUpdateDisabled" (click)="updateReconciliationAsync(fuelSlip); $event.stopPropagation()">
                        @if (isEditLoading) {
                          <span class="spinner-border spinner-border-sm"></span>
                        } @else {
                          <img src="assets/icons/update-icon.svg" alt="" style="width:16px;height:16px;" />
                        }
                        {{ t('reconciledTable.updateReconciliation') }}
                      </button>
                    </div>

                  </div><!-- /.edit-frame -->
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    }
  </table>
  </div>
</div>

<div class="d-flex align-items-center justify-content-between bottom-options">
  <p class="pageination-text">{{ 'common.showingOutOf' | transloco: { current: currentItems, total: totalItems } }}</p>
  <app-pagination [totalPages]="numberOfPages" [currentPage]="currentPage"
    (pageChange)="createPagination($event)"></app-pagination>
  <div class="export-listing" [class.invisible]="true">
    <div class="common-drop-down dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
        aria-expanded="false">
        {{ 'common.export' | transloco }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdown-button">
        <li><a class="dropdown-item">{{ t('export.exportAsPdf') }}</a></li>
        <li><a class="dropdown-item">{{ t('export.exportAsCsv') }}</a></li>
        <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
      </ul>
    </div>
  </div>
</div>
</ng-container>
